import React, { useEffect, useState } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button } from "reactstrap"
// import "./datatables.scss";
// import '../Icons/IconFontawesome';

import Utils from '../../Utility';
import { post, get, put, del, download } from "../../../helpers/api_helper";
import DeleteModal from '../../../components/ConfirmModal/DeleteModal';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import { AvField, AvForm } from "availity-reactstrap-validation";
import { saveAs } from 'file-saver';
import defaultImage from '../../../assets/images/brands/default-image.avif';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

// import './product.scss';

const Table = (props) => {
  const { user, role, from, setLoading, loading, currentData, setCurrentData, setFile, setThumb, setTag } = props;
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [error, setError] = useState(false);


  useEffect(() => {
    if (user) {
      getData();
    }
  }, [user]);

  const getData = () => {
    if (!loading) {
      setLoading(true);
      get("/project", { token: user?.token })
        .then(json => {
          setLoading(false)
          console.log('response from get project list', json);
          if (json?.statusCode == 200) {
            setData(json?.data);
          } else {
            toast.error(json?.error);
            setError(true);
          }
        })
        .catch(error => {
          setLoading(false);
          console.log('error while getting project list', error);
          toast.error('Something Went Wrong!');
        })
    }
  }

  useEffect(() => {
    setColumns([
      {
        name: "Position",
        cell: (row, index) => <>
          <Draggable key={row._id} draggableId={row._id} index={index}>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
              >
                <i className="mdi mdi-menu" style={{ fontSize: 20, color: Utils.textColor }}></i>
              </div>
            )}
          </Draggable>
        </>,
        selector: row => row?._id,
        // maxWidth: '100px'
      },
      {
        name: "Thumb",
        cell: (row) => <>
          {/* <img src={row?.thumb} style={{ width: 70, height: 70, padding: 10 }} /> */}
          <img src={row?.thumb} style={{ width: 70, height: 70, padding: 10 }} />

        </>,
        selector: row => row?.thumb,
        // maxWidth: '100px',
        // maxWidth: '100px'
      },

      // {
      //   name: "Image",
      //   cell: (row) => <>
      //     {/* <img src={row?.images?.length ? row?.images[0] : ""} style={{ width: 60 }} /> */}
      //     <img src={row?.images?.length ? row?.images[0] : ""} style={{ width: 100, height: 70, padding: 10 }} />
      //   </>,
      //   maxWidth: '150px',
      //   minWidth: '100px'
      // },
      // {
      //   name: 'Image',
      //   cell: (row) => <>
      //     {/* <img title={'logo'} src={row?.image} style={{ width: 70, height: 'auto' }} /> */}
      //     <img src={row?.images !== "" ? row.images[0] : defaultProfilePic} style={{ width: 70, height: 70, padding: 10 }} />

      //   </>,
      //   maxWidth: '150px'
      // },
      {
        name: 'Images',
        cell: (row) => (
          <>
            <img
              src={row?.images?.length ? row.images[0] : defaultImage}
              alt=""
              style={{ width: 86, height: 70, padding: 10 }}
            />
          </>
        ),
        selector: row => row?.images?.length ? row?.images[0] : 0,
        // maxWidth: '130px',
      },
      {
        name: 'Title',
        // selector: row => row?.title,
        cell: (row) => <>
          <span>{row?.title}</span>
        </>,
        selector: row => row?.title,
        // maxWidth: '150px',
      },
      {
        name: 'Platform',
        selector: row => row?.platform,
        cell: (row) => <>
          <span> {row?.platform}</span>
        </>,
        // maxWidth: "100px"
      },
      {
        name: 'Location',
        selector: row => row?.location,
        // maxWidth: '160px',
      },
      {
        name: 'Type',
        selector: row => row?.type?.map((item) => item?.title + ","),
        // maxWidth: '160px',
      },
      {
        cell: (row) => <>
          <Button onClick={() => handleUpdateStatus(row)}
            title={row?.isActive ? "Inactive" : "Active"}
            style={{ backgroundColor: !row.isActive ? 'red' : 'green', marginRight: 9, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}>
            <span className="text-white" style={{}}>
              {!row?.isActive ? 'Inactive' : 'Active'}
            </span>
          </Button>
        </>,
        name: 'Status',
        // maxWidth: '110px',
        ignoreRowClick: true,
      },
      {
        cell: (row) => <>
          {/* <Button onClick={() => props?.history.push(`/product/` + row?._id)}
            title={"View"}
            style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}><span className="mdi mdi-eye" style={{ fontSize: 20 }}></span></Button> */}
          {/* {from != 'Dashboard' && */}
          <>
            <Button onClick={() => handleUpdateProj(row)}
              title={"Edit"}
              style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none', height: 44 }}><span className="mdi mdi-pencil" style={{ fontSize: 20, color: Utils.textColor }}></span></Button>
            <Button onClick={() => handleDelete(row)}
              title={"Delete"}
              style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none', height: 44 }}><span className="mdi mdi-delete" style={{ fontSize: 20, color: Utils.textColor }}></span></Button>
          </>
          {/* } */}
        </>,
        name: 'Action',
        // maxWidth: '110px',
        // minWidth: '100px',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ])
  }, [data]);

  const handleUpdateProj = (proj) => {
    console.log('updating proj', proj);
    props?.setCurrentData(proj);
    props.add(true);
  }

  const handleUpdateStatus = (row) => {
    setCurrentData({ ...row, actionType: "Status" });
    setDeleteModal(true);
  }

  const handleDelete = (row) => {
    setCurrentData({ ...row, actionType: "Delete" });
    setDeleteModal(true);
  }

  const onStatus = () => {
    console.log('status', currentData);
    setLoading(true);
    let body = {
      projectId: currentData?._id,
      isActive: !currentData?.isActive,
      token: user?.token
    }
    let url = `/project`;
    put(url, body)
      .then(json => {
        console.log('response from update status', json);
        setLoading(false);
        if (json.statusCode == 200) {
          toast.success(json?.message);
          setDeleteModal(false);
          getData();
          setCurrentData(null);
        } else {
          toast.error(json?.error);
        }
      })
      .catch(error => {
        setLoading(false);
        toast.error(error);
        console.error('error while deleting user', error);
      })
  }

  const onDelete = () => {
    console.log('deleted', currentData);
    let body = {
      projectId: currentData?._id,
      token: user?.token
    }
    del(`/project`, body)
      .then(json => {
        console.log('response from delete user', json);
        if (json.statusCode == 200) {
          toast.success(json?.message);
          getData();
          setDeleteModal(false);
          setCurrentData(null);
        }
      })
      .catch(error => {
        console.error('error while deleting user', error);
      })
  }

  const ExpandedComponent = ({ data }) =>
    <div className='expending_box'>
      <Row>
        <Col lg={1}>
          <div className='expend_detail'>
            <h5><b>Tech : </b></h5>
          </div>
        </Col>
        <Col lg={11}>
          <div className='expend_detail'>
            <p>{data?.tech?.map((tag, index) => (
              <span key={index}>
                {tag.title}
                {index !== data?.tech?.length - 1 && ", "}
              </span>
            ))}</p>
          </div>
        </Col>
        <Col lg={1}>
          <div className='expend_detail'>
            <h5><b>Tags : </b></h5>
          </div>
        </Col>
        <Col lg={11}>
          <div className='expend_detail'>
            <p>{data?.tag?.map((tag, index) => (
              <span key={index}>
                {tag.title}
                {index !== data?.tag?.length - 1 && ", "}
              </span>
            ))}</p>
          </div>
        </Col>
        <Col lg={1}>
          <div className='expend_detail'>
            <h5><b>Description : </b></h5>
          </div>
        </Col>
        <Col lg={11}>
          <div className='expend_detail'>
            <p>{data?.desc}</p>
          </div>
        </Col>
      </Row>
    </div>

  const handleDragEnd = (result) => {
    // console.log('dragging item', result);
    // Handle the drag-and-drop logic here
    if (!result.destination) return; // Item was dropped outside the list
    const items = [...data];
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    let ids = [], position = [];
    items.forEach((item, index) => {
      ids.push(item?._id);
      position.push(index);
    })
    let body = {
      ids,
      position,
      token: user?.token
    }
    put("/project/position", body)
      .then(res => {
        // if (res?.statusCode == 200)
        setData(items);
      })
  };

  return (
    <React.Fragment>
      <div className="">
        <Row>
          <DeleteModal
            show={deleteModal}
            onDeleteClick={() => currentData?.actionType == 'Status' ? onStatus() : onDelete()}
            // onDeleteClick={() => onDelete()}
            onCloseClick={() => setDeleteModal(false)}
            data={currentData}
            actionType={currentData?.actionType}
          />
          <Col className="col-12">
            <Card>
              <CardBody>
                {from != 'Dashboard' &&
                  <div className="d-flex" style={{ marginLeft: 'auto', marginBottom: 30 }}>
                    <div>
                      <CardTitle className="h4">{props.role}</CardTitle>
                      <CardSubtitle className="mb-3">
                        {/* {role} you have added before,<code> Anybody</code> can <code>check</code> and <code>visit</code> on these. if <code>Status</code> is Active. */}
                      </CardSubtitle>
                    </div>
                    {!error &&
                      <div className="text-center" style={{ marginLeft: 'auto' }}>
                        <Button style={{ backgroundColor: Utils.themeColor, border: 'none', color: Utils.textColor }} onClick={() => { props?.add(true); setTag([]) }}>
                          Add
                        </Button>
                      </div>
                    }
                  </div>
                }
                <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="table">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        <DataTable
                          columns={columns}
                          data={data}
                          pagination
                          paginationPerPage={100}
                          paginationRowsPerPageOptions={[100, 200, 300, 400]}
                          expandableRows={true}
                          expandOnRowClicked={false}
                          expandableRowDisabled={row => row.disabled}
                          expandableRowsComponent={ExpandedComponent}
                          expandableRowsComponentProps={row => row.Action}
                          customStyles={{
                            headCells: {
                              style: {
                                color: 'black',
                                fontWeight: 'bold',
                                fontSize: 15,
                              },
                            },
                          }}
                        // onRowClicked={(r, e) => seenNoti(r)}
                        />
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

    </React.Fragment>
  )
}

export default Table;
